import { BaseModel } from '../../../models'

export class Course extends BaseModel {
  public name: string
  public instructor: string
  public coInstructor: string
  public deactivateOn: Date
  public startDate: Date
  public endDate: Date
  public price: string
  public location: string
  public testLine: string
  public schedule: string
  public active: boolean
  public cartUrl: string
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/course/course.ts